import { render, staticRenderFns } from "./tableSolved.vue?vue&type=template&id=7554c2c0&scoped=true"
import script from "./tableSolved.vue?vue&type=script&lang=js"
export * from "./tableSolved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554c2c0",
  null
  
)

export default component.exports